import styles from "./filters-modal-content.module.css";

import { useContext, useState } from "react";

import { Descriptions, Flex, Divider, Space, Typography } from "antd";

import MainContext from "@/layouts/MainLayout/context";

import CustomSelect from "@/components/inputs/CustomSelect";
import CustomTreeSelect from "@/components/inputs/CustomTreeSelect";

import {
  FILTER_NAMES,
  ACCESS_LEVELS,
  NOT_FILLED_OPTION,
} from "@/constants/tasks";

const withNotFilled = (options = []) => [NOT_FILLED_OPTION, ...options];

export const FiltersModalContent = ({
  isAdmins,
  tempValueFilters,
  units,
  unitsTree,
  statuses,
  priorities,
  taskTypes,
  employees,
  sprints,
  user,
  handleTempFilterChange,
}) => {
  const { config } = useContext(MainContext);
  const [authorSelectOpen, setAuthorSelectOpen] = useState(false);
  const [executorSelectOpen, setExecutorSelectOpen] = useState(false);
  const sprintName = config?.entities?.sprint?.name?.singular || "Спринт";

  return (
    <Descriptions
      column={1}
      colon={false}
      styles={{
        label: {
          display: "inline-block",
          minWidth: "150px",
          color: "#777777",
        },
        content: {
          display: "block",
          marginLeft: "8px",
        },
      }}
    >
      {isAdmins ? (
        <Descriptions.Item
          label="Рабочая группа"
          className={styles.modalFilter}
        >
          <CustomSelect
            placeholder="Начните вводить"
            options={units}
            fieldNames={{
              label: "name",
              value: "uuid",
              key: "uuid",
            }}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="name"
            allowClear
            popupMatchSelectWidth={false}
            value={tempValueFilters?.unit_uuid}
            onChange={(unit) =>
              handleTempFilterChange(FILTER_NAMES.UNIT_UUID, unit)
            }
          />
        </Descriptions.Item>
      ) : (
        <>
          <Descriptions.Item
            label="Рабочая группа"
            className={styles.modalFilter}
          >
            <CustomTreeSelect
              placeholder="Начните вводить"
              data={unitsTree}
              value={tempValueFilters?.units_uuids}
              onChange={(units_uuids) => {
                handleTempFilterChange(FILTER_NAMES.UNITS_UUIDS, units_uuids);
              }}
              style={{ width: "100%" }}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Тип" className={styles.modalFilter}>
            <CustomSelect
              options={ACCESS_LEVELS}
              style={{ width: "100%" }}
              popupMatchSelectWidth={false}
              value={tempValueFilters?.access_level}
              onChange={(val) =>
                handleTempFilterChange(FILTER_NAMES.ACCESS_LEVEL, val)
              }
              optionRender={(option) => (
                <Flex gap={5} align="center">
                  {option?.data?.icon}
                  <span>{option.label}</span>
                </Flex>
              )}
              labelRender={(option) => {
                const item = ACCESS_LEVELS.find(
                  (item) => item.value === option.value,
                );
                return (
                  <Flex gap={5} align="center">
                    {item?.icon}
                    <span>{item.label}</span>
                  </Flex>
                );
              }}
            />
          </Descriptions.Item>
        </>
      )}

      <Descriptions.Item label={sprintName}>
        <CustomSelect
          placeholder="Начните вводить"
          options={withNotFilled(sprints)}
          fieldNames={{
            label: "name",
            value: "uuid",
            key: "uuid",
          }}
          style={{
            width: "100%",
          }}
          showSearch
          optionFilterProp="name"
          allowClear
          popupMatchSelectWidth={false}
          value={tempValueFilters.sprint_uuid}
          onChange={(val) => handleTempFilterChange("sprint_uuid", val)}
        />
      </Descriptions.Item>

      <Descriptions.Item label="Тип задачи">
        <CustomSelect
          placeholder="Начните вводить"
          options={taskTypes}
          fieldNames={{
            label: "name",
            value: "uuid",
            key: "uuid",
          }}
          style={{
            width: "100%",
          }}
          showSearch
          optionFilterProp="name"
          allowClear
          popupMatchSelectWidth={false}
          value={tempValueFilters.task_type_uuid}
          onChange={(val) => handleTempFilterChange("task_type_uuid", val)}
        />
      </Descriptions.Item>

      <Descriptions.Item label="Статус">
        <CustomSelect
          mode="multiple"
          placeholder="Начните вводить"
          options={statuses}
          fieldNames={{
            label: "name",
            value: "uuid",
            key: "uuid",
          }}
          style={{ width: "100%" }}
          maxTagCount="responsive"
          showSearch
          optionFilterProp="name"
          allowClear
          popupMatchSelectWidth={false}
          value={tempValueFilters?.status_uuid}
          onChange={(val) => {
            handleTempFilterChange(FILTER_NAMES.STATUS_UUID, val);
          }}
        />
      </Descriptions.Item>

      <Descriptions.Item label="Приоритет">
        <CustomSelect
          placeholder="Начните вводить"
          options={priorities.filter(({ deleted }) => !deleted)}
          fieldNames={{
            label: "name",
            value: "uuid",
            key: "uuid",
          }}
          style={{ width: "100%" }}
          showSearch
          optionFilterProp="name"
          allowClear
          popupMatchSelectWidth={false}
          value={tempValueFilters?.importance_uuid}
          onChange={(val) =>
            handleTempFilterChange(FILTER_NAMES.IMPORTANCE_UUID, val)
          }
        />
      </Descriptions.Item>

      <Descriptions.Item label="Автор">
        <CustomSelect
          open={authorSelectOpen}
          onOpenChange={setAuthorSelectOpen}
          placeholder="Начните вводить"
          value={tempValueFilters?.author_uuid}
          options={employees}
          showSearch
          allowClear
          fieldNames={{ value: "uuid" }}
          optionFilterProp="label"
          style={{ width: "100%" }}
          placement="topRight"
          popupMatchSelectWidth={false}
          onChange={(val) =>
            handleTempFilterChange(FILTER_NAMES.AUTHOR_UUID, val)
          }
          popupRender={(menu) => (
            <>
              {menu}
              {employees.map((u) => u.uuid).includes(user.employee_uuid) && (
                <>
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Typography.Link
                      onClick={() => {
                        handleTempFilterChange(
                          FILTER_NAMES.AUTHOR_UUID,
                          user.employee_uuid,
                        );
                        setAuthorSelectOpen(false);
                      }}
                    >
                      Я автор
                    </Typography.Link>
                  </Space>
                </>
              )}
            </>
          )}
        />
      </Descriptions.Item>

      <Descriptions.Item label="Исполнитель">
        <CustomSelect
          open={executorSelectOpen}
          onOpenChange={setExecutorSelectOpen}
          placeholder="Начните вводить"
          value={tempValueFilters?.responsible_executor_uuid}
          options={withNotFilled(employees)}
          showSearch
          allowClear
          fieldNames={{ value: "uuid" }}
          optionFilterProp="label"
          style={{ width: "100%" }}
          placement="topRight"
          popupMatchSelectWidth={false}
          onChange={(val) =>
            handleTempFilterChange(FILTER_NAMES.RESPONSIBLE_EXECUTOR_UUID, val)
          }
          popupRender={(menu) => (
            <>
              {menu}
              {employees.map((u) => u.uuid).includes(user.employee_uuid) && (
                <>
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Typography.Link
                      onClick={() => {
                        handleTempFilterChange(
                          FILTER_NAMES.RESPONSIBLE_EXECUTOR_UUID,
                          user.employee_uuid,
                        );
                        setExecutorSelectOpen(false);
                      }}
                    >
                      Я исполнитель
                    </Typography.Link>
                  </Space>
                </>
              )}
            </>
          )}
        />
      </Descriptions.Item>
    </Descriptions>
  );
};
